import qs from 'qs'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import {
  InvoiceFilterModel,
  InvoicesTableModel,
  ObjectionTableModel
} from '../../../../pages/invoicesPage/invoicesPage.Model'
import { ClosedSettlementsSearchRequest } from '../../../../pages/settlements/settlements.models'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { EnumDominioTarea } from '../../../oData/enums/enumDominioTarea'
import { ProductConceptModel } from '../../model/contracts'
import { SettlementTableModel } from '../settlements/model/settlements'
import {
  GenerateInvoiceFloatingConceptModel,
  InvoiceAnnexedParamModel,
  InvoiceDetailResponseModel,
  InvoiceResponseModel
} from './model/invoices'

export const apiFetchInvoices = async (
  invoiceFilter: InvoiceFilterModel
): Promise<InvoicesTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Invoices`, invoiceFilter).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchCriticalityTypes = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Invoices/FetchCriticalityTypes`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchObjectionsDescriptions = async (
  taskDomain?: EnumDominioTarea
): Promise<ObjectionTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Invoices/FetchObjectionsDescriptions`, {
    params: {
      taskDomain
    }
  }).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchObjectionsByInvoiceID = async (
  invoiceID: number
): Promise<ObjectionTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Invoices/${invoiceID}/Objections`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiSaveObjection = async (
  objection: ObjectionTableModel
): Promise<ObjectionTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Invoices/PostObjections`, [objection]).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiDeleteObjection = async (objectionID: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    `${apiSuffixUrl}/api/Invoices/DeleteObjection?objectionID=${objectionID}`
  ).then(response => {
    return response.data
  })
}

export const apiGetInvoiceById = async (
  invoiceID: number,
  expand?: boolean
): Promise<InvoiceResponseModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const params = {
    expand
  }
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Invoices/GetInvoiceById(${invoiceID})`, {
    params
  }).then(response => {
    if (response) {
      return response.data
    }
  })
}

export const apiGetInvoiceDetailsById = async (
  invoiceID: number
): Promise<InvoiceDetailResponseModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Invoices/GetInvoiceDetailsById(${invoiceID})`
  ).then(response => {
    return response.data
  })
}

export const apiGetInvoiceByExecutionCycleID = async (
  executionCycleId: number,
  issuedOnly: boolean,
  subjectType?: number
): Promise<SettlementTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const params = {
    subjectType,
    issuedOnly
  }
  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Invoices/ExecutionCycle(${executionCycleId})`,
    { params }
  ).then(response => {
    if (response) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetInvoicesByEmissionDate = async (
  request: ClosedSettlementsSearchRequest
): Promise<SettlementTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Invoices/GetInvoicesByEmissionDate`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetProductConcepts = async (
  productIds: number[]
): Promise<ProductConceptModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/api/products/concepts`, {
    params: { productIds },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  }).then(response => response.data)
}

export const apiGetDeliveryNotes = async (invoiceID: number): Promise<InvoiceResponseModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Invoices/DeliveryNotes?invoiceID=${invoiceID}`
  ).then(response => {
    if (response) {
      return response.data
    }
  })
}

export const apiGenerateFloatingConceptsInvoice = async (
  floatingConcepts: GenerateInvoiceFloatingConceptModel
): Promise<GenerateInvoiceFloatingConceptModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Invoices/GenerateFloatingConceptsInvoice`,
    floatingConcepts
  ).then(response => {
    if (response) {
      return response.data
    }
  })
}

export const apiRevertInvoicesToDraft = async (invoiceIds: number[]): Promise<void> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Invoices/RevertInvoicesToDraft`, {
    invoiceIds
  }).then(response => response.data)
}

// Invoice Annexed Params

export const apiGetInvoiceAnnexedParam = async (
  invoiceID: number
): Promise<InvoiceAnnexedParamModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Invoices(${invoiceID})/Annexes`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiPostInvoiceAnnexedParam = async (
  invoiceID: number,
  request: InvoiceAnnexedParamModel
): Promise<InvoiceAnnexedParamModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Invoices(${invoiceID})/Annexes`,
    request
  ).then(response => {
    if (response) {
      return response.data
    }
  })
}

export const apiPutInvoiceAnnexedParam = async (
  invoiceID: number,
  invoiceAnnexedParamId: number,
  request: InvoiceAnnexedParamModel
): Promise<InvoiceAnnexedParamModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.put(
    `${apiSuffixUrl}/api/Invoices(${invoiceID})/Annexes(${invoiceAnnexedParamId})`,
    request
  ).then(response => {
    if (response) {
      return response.data
    }
  })
}

export const apiGenerateCancellationConcepts = async (
  invoiceIDs: number[],
  recalcularPenalizaciones: boolean
): Promise<number[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Invoices/GenerateCancellationConcepts`, {
    invoiceIDs,
    recalcularPenalizaciones
  }).then(response => {
    if (response) {
      return response.data
    }
  })
}

/**
 * Deprecated: Please use createSettlementBatch (Lote tipo Repintado) instead.
 * @param invoiceIds
 * @returns void
 */
export const apiRenderInvoices = async (invoiceIds: number[]): Promise<void> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Invoices/InvoiceRendering`, {
    invoiceIds
  }).then(response => {
    return response.data
  })
}
